import { mantineTheme } from 'init/mantine';

export type HeatStep = { fill: string; ink: string };

const INK_ON_LIGHT = mantineTheme.colors.black[0];
const INK_ON_DARK = mantineTheme.colors.gray[0];

export const COLLECTION_COHORTS_RAMP: ReadonlyArray<HeatStep> = [
  { fill: mantineTheme.colors.purple[2], ink: INK_ON_LIGHT },
  { fill: mantineTheme.colors.purple[3], ink: INK_ON_LIGHT },
  { fill: mantineTheme.colors.purple[4], ink: INK_ON_LIGHT },
  { fill: mantineTheme.colors.purple[6], ink: INK_ON_DARK },
  { fill: mantineTheme.colors.purple[7], ink: INK_ON_DARK },
];

export const toRampStep = (share: number): HeatStep => {
  const step = Math.floor(share * COLLECTION_COHORTS_RAMP.length);
  const lastIndex = COLLECTION_COHORTS_RAMP.length - 1;

  return COLLECTION_COHORTS_RAMP[Math.max(0, Math.min(lastIndex, step || 0))];
};
